import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import './index.css';

/**
 * ConfirmPopUp component, this functional component is using for the confirmation
 * @props handleOk
 * @param modalOpen
 * @props cancelDescription
 */

const ConfirmPopUp = (props) => {
  return (
    <React.Fragment>
      <Modal
        visible={props.isModalOpen}
        closable={false}
        onOk={props.handleOk}
        onCancel={props.togglePopUp}
        footer={[
          <Button key="back" onClick={props.togglePopUp}>
            {props.cancelText}
          </Button>,
          <Button key="submit" type="primary" onClick={props.handleOk}>
            {props.isLoading ? <i className="fa fa-spinner"></i> : null}
            {props.confirmText}
          </Button>
        ]}>
        <p className="popup-header">
          <p
            className="fa fa-exclamation-circle"
            style={{ color: '#FAAD14' }}></p>
          &nbsp;&nbsp;
          <strong className="popup-header-text">{props.headerText}</strong>
        </p>
        <div style={{ marginLeft: '20px' }} className="popup-body">
          {props.bodyText}
        </div>
      </Modal>
    </React.Fragment>
  );
};
/**
 * Proptypes
 * @type {modalOpen,handleOk,togglePopUp}
 */
ConfirmPopUp.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  handleOk: PropTypes.func.isRequired,
  togglePopUp: PropTypes.func.isRequired,
  headerText: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default ConfirmPopUp;
